import { addDoc, collection, serverTimestamp, Timestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';

export const ADMIN_UPDATES_COLLECTION = 'adminUpdates';
export const ADMIN_UPDATE_RETENTION_DAYS = 30;

export const getAdminUpdateExpiryDate = (fromDate = new Date()) => {
  const expiresAt = new Date(fromDate);
  expiresAt.setDate(expiresAt.getDate() + ADMIN_UPDATE_RETENTION_DAYS);
  return expiresAt;
};

const normalizeComparableValue = (value) => {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value?.toDate === 'function') return value.toDate().toISOString();
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return JSON.stringify(value);
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const formatAdminDate = (value) => {
  if (!value) return '';
  const date = typeof value?.toDate === 'function'
    ? value.toDate()
    : value instanceof Date
      ? value
      : new Date(value);

  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatAdminDateTime = (value) => {
  if (!value) return '';
  const date = typeof value?.toDate === 'function'
    ? value.toDate()
    : value instanceof Date
      ? value
      : new Date(value);

  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatAdminBoolean = (value) => (value ? 'Si' : 'No');

export const buildChangeDescription = (prefix, before = {}, after = {}, fields = []) => {
  const changes = fields
    .map((field) => {
      const beforeValue = field.getBefore ? field.getBefore(before) : before?.[field.key];
      const afterValue = field.getAfter ? field.getAfter(after) : after?.[field.key];
      const beforeComparable = field.compare
        ? field.compare(beforeValue)
        : field.format
          ? field.format(beforeValue)
          : normalizeComparableValue(beforeValue);
      const afterComparable = field.compare
        ? field.compare(afterValue)
        : field.format
          ? field.format(afterValue)
          : normalizeComparableValue(afterValue);

      if (beforeComparable === afterComparable) return null;
      if (field.renderChange) return field.renderChange(beforeValue, afterValue, before, after);

      const renderedValue = field.format
        ? field.format(afterValue)
        : normalizeComparableValue(afterValue);
      return `${field.label}: ${renderedValue || '-'}`;
    })
    .filter(Boolean);

  return changes.length > 0 ? `${prefix}: ${changes.join(', ')}` : `${prefix}: nessun campo pubblico modificato`;
};

export const recordAdminUpdate = async ({
  type,
  action,
  title,
  description = '',
  entityType = '',
  entityId = '',
  metadata = {}
}) => {
  if (!type || !action || !title) return null;

  const currentUser = auth.currentUser;

  try {
    return await addDoc(collection(db, ADMIN_UPDATES_COLLECTION), {
      type,
      action,
      title,
      description,
      entityType: entityType || type,
      entityId: entityId || '',
      metadata,
      createdAt: serverTimestamp(),
      expiresAt: Timestamp.fromDate(getAdminUpdateExpiryDate()),
      actorUid: currentUser?.uid || '',
      actorEmail: currentUser?.email || '',
      actorName: currentUser?.displayName || currentUser?.email || 'Admin'
    });
  } catch (error) {
    console.warn('Aggiornamento admin non registrato:', error);
    return null;
  }
};
